import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Box, Grid, useTheme, Paper, Link, FormGroup, Checkbox, FormControlLabel } from '@mui/material';
import { purple, teal } from '@mui/material/colors';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { CloudUpload } from '@mui/icons-material';
import axios from "../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate, useLocation } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import HouseIcon from '@mui/icons-material/House';
import ConfirmationDialog from '../ReusableDailog';
import CrudButtons from '../../GlobalFunction/CrudButtons';
import DescriptionIcon from '@mui/icons-material/Description';

function InfoBoard() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        NtcbrdNo: '',
        NtcbrdDt: '',
        NtcbrdSubj: '',
        NtcbrdDesc: '',
        Attachment: '',
        ImgName: '',
        Status: '',
        CreatedBy: '1',
    });
    const theme = useTheme();
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [location, setLocation] = useState(useLocation());
    const [currentNoticeID, setCurrentNoticeID] = useState(null);
    const [PropertyDrp, setPropertyDrp] = useState([]);
    const [mode, setMode] = useState('view');
    const [Status, setStatus] = useState("1");
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [lastInsertedNoticeID, setLastInsertedNoticeID] = useState(null);
    const [ImgName, setImgName] = useState(null);
    const [Attachment, setAttachment] = useState(null);
    const [currentPropertyId, setCurrentPropertyId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [fileName, setFileName] = useState("");
    const [fileType, setFileType] = useState("");
    const [date, setDate] = useState(dayjs());
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        if (location.state && location.state.NtcbrdId) {
            setCurrentNoticeID(location.state.NtcbrdId);
            fetchNoticeData(location.state.NtcbrdId);
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
            const currentDate = dayjs();
            setDate(currentDate);
            setFormData(prevState => ({
                ...prevState,
                NtcbrdDt: currentDate.format("YYYY-MM-DD")
            }));
        }
    }, [location]);

    const formatDate = (dateStr) => {
        if (!dateStr) return "";

        const date = new Date(dateStr);
        if (isNaN(date)) return "";

        return date.toISOString().split("T")[0];
    };

    const fetchNoticeData = async (id, flag) => {
        try {
            const response = await axios.post('TrnNtcbrd/RetriveTrnNtcbrd', {
                NtcbrdId: parseInt(id),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const noticeData = response.data.Data[0];
                const fixedImageUrl = noticeData.Attachment.startsWith('http:/')
                    ? noticeData.Attachment.replace('http:/', 'http://')
                    : noticeData.Attachment;
                setFormData({
                    NtcbrdNo: noticeData.NtcbrdNo,
                    NtcbrdDt: formatDate(noticeData.NtcbrdDt),
                    NtcbrdSubj: noticeData.NtcbrdSubj,
                    NtcbrdDesc: noticeData.NtcbrdDesc,
                    ImgName: noticeData.ImgName,
                    Attachment: fixedImageUrl,
                    NtcbrdId: noticeData.NtcbrdId
                });
                setDate(dayjs(noticeData.NtcbrdDt));
                setIsFormDisabled(true);
                setCurrentNoticeID(noticeData.NtcbrdId);
            }
        } catch (error) {
            // toast.error('Error fetching data. Please try again.');
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const InputChange = (value, delta, source, editor) => {
        setFormData(prevState => ({
            ...prevState,
            NtcbrdDesc: value,
            NtcbrdDesc_text: editor.getText().trim()
        }));
    };

    const fetchPropertyData = async () => {
        const Flag = "";
        try {
            const response = await axios.post(
                `PropertyMst/GetPropertyMstUserwisedrp`,
                { Flag, UserId },
            );
            if (response.data.Status === 0) {
                setPropertyDrp(response.data.Data);
                setCurrentPropertyId(response.data.Data[0].PropId);
            }
        } catch (error) {
            toast.error('Error fetching property data');
        }
    };

    useEffect(() => {
        fetchPropertyData();
    }, []);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                const base64String = reader.result;

                setFormData((prev) => ({
                    ...prev,
                    Attachment: base64String, // Set the base64 string of the file
                    ImgName: file.name, // Set the image name as the file name
                }));
                setFileName(file.name);  // Optionally save file name separately
                setFileType(file.type);  // Optionally save file type separately
            };
            reader.readAsDataURL(file);  // Read the file as a base64 string
        }
    };

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
        if (checked) {
            setSelectedOptions([...selectedOptions, value]);
        } else {
            setSelectedOptions(selectedOptions.filter((item) => item !== value));
        }
    };

    const handleSaveButton = async () => {
        const payload = selectedOptions.map(prop => ({
            NtcbrdId: parseInt(currentNoticeID),
            PropId: parseInt(prop),
            NtcAllcBy: 1
        }));

        try {
            let response;
            if (mode === "edit") {
                response = await axios.post(`TrnNtcbrd/MangeTrnNtcbrdAllc`, payload);
            } else {
                response = await axios.post(`TrnNtcbrd/MangeTrnNtcbrdAllc`, payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                // toast.success(response.data.Message);
            } else {
                toast.error(response.data.Message || "Operation failed");
            }
        } catch (error) {
            toast.error("Error saving/updating Data. Please try again.");
        }
    };

    const handleSave = () => {
        setOpenConfirmDialog(false);
    };

    const handleSubmit = async () => {
        try {
            const fileName = formData.ImgName ? formData.ImgName : '';
            const payload = {
                NtcbrdId: currentNoticeID ? parseInt(currentNoticeID) : 0,
                NtcbrdNo: formData.NtcbrdNo || '',
                NtcbrdSubj: formData.NtcbrdSubj || '',
                NtcbrdDesc: formData.NtcbrdDesc || '',
                NtcbrdDt: formData.NtcbrdDt || '',
                Attachment: formData.Attachment || '',
                ImgName: fileName || '',
                Status: Status,
                CreatedBy: '1',
            };

            let response;

            if (mode === 'edit') {
                payload.NtcbrdId = currentNoticeID;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axios.post(`TrnNtcbrd/UpdateTrnNtcbrd`, payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axios.post(`TrnNtcbrd/InsertTrnNtcbrd`, payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);

                if (mode === 'add') {
                    const newNoticeId = response.data.Data;
                    setCurrentNoticeID(newNoticeId);
                    setMode('view');
                    setIsFormDisabled(true);
                    await fetchNoticeData(newNoticeId);
                } else {
                    setMode('view');
                    setIsFormDisabled(true);
                    await handleSaveButton();
                }
            } else {
                toast.error(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            toast.error('Error saving/updating Data. Please try again.');
        }
    };

    const handleDeleteConfirm = async () => {
        try {
            if (!currentNoticeID || !UserId) {
                toast.warn("Invalid notice ID or user ID.");
                return;
            }
            const response = await axios.post('TrnNtcbrd/DeleteTrnNtcbrd', {
                NtcbrdId: currentNoticeID,
                ActionBy: UserId,
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message || "Notice deleted successfully.");
                await fetchNoticeData(currentNoticeID, "P");
            }
        } catch (error) {
            toast.error("Error while deleting the record. Please try again.");
        }
        setOpenDelete(false);
    };

    const handleDeleteClick = () => {
        setOpenDelete(true);
    };

    const handleDeleteCancel = () => {
        setOpenDelete(false);
    };

    const handleHostel = () => {
        setOpenConfirmDialog(true);
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setCurrentNoticeID(null);
        setSelectedOptions([]);
        setDate(dayjs());
        setFormData({
            NtcbrdNo: '',
            NtcbrdDt: dayjs().format("YYYY-MM-DD"),
            NtcbrdSubj: '',
            NtcbrdDesc: '',
            Attachment: '',
            ImgName: '',
        });
    };

    const handleEdit = () => {
        if (!currentNoticeID) {
            toast.warn("No notice selected to edit");
            return;
        }
        setMode('edit');
        setIsFormDisabled(false);
    };

    const handleCancel = async () => {
        try {
            await fetchNoticeData(1, "L");
            setStatus("1");
            setMode("view");
            setIsFormDisabled(true);
        } catch (error) {
            toast.error("Error while canceling.");
        }
    };

    const handlePrint = () => {
        window.print();
    };

    const handleExit = () => {
        navigate('/info-board-table');
    };

    const closeConfirmation = () => {
        setOpenConfirmDialog(false);
    };

    const filteredProperties = PropertyDrp.filter((option) =>
        option.Name.toLowerCase().includes(searchText.toLowerCase())
    );

    return (
        <>
            <Box sx={{ maxWidth: 'lg', margin: '0 auto', padding: 1, mt: 4 }}>
                <ToastContainer />
                <Paper sx={{ padding: 3, borderRadius: 2, boxShadow: 10 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: 1,
                            flexDirection: { xs: 'column', sm: 'row' },
                        }}
                    >
                        <Typography variant="h4"
                            sx={{
                                fontWeight: '100',
                                background: 'linear-gradient(45deg, #6a1b9a, #ff4081, #3f51b5, #635bff)',
                                WebkitBackgroundClip: 'text',
                                backgroundClip: 'text',
                                color: 'transparent',
                            }}
                        >
                            Notice Board
                        </Typography>

                        <Link
                            onClick={handleHostel}
                            variant="body2"
                            sx={{ cursor: 'pointer', textAlign: 'end' }}
                        >
                            Apply Property
                        </Link>

                        <CrudButtons
                            moduleName={"Notice Board"}
                            mode={mode}
                            onAdd={handleAdd}
                            onEdit={handleEdit}
                            onView={handlePrint}
                            onDelete={() => setOpenDelete(true)}
                            onExit={handleExit}
                            readOnlyMode={isFormDisabled}
                            sx={{ marginTop: { xs: 2, sm: 0 } }}
                        />
                    </Box>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                id="NtcbrdNo"
                                name="NtcbrdNo"
                                label="Notice No"
                                variant="filled"
                                fullWidth
                                className="custom-textfield"
                                value={formData.NtcbrdNo}
                                onChange={handleInputChange}
                                disabled={true}
                            />
                        </Grid>

                        {/* Board Date */}
                        <Grid item xs={12} md={6}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Date"
                                    value={date}
                                    disabled={isFormDisabled}
                                    onChange={(newDate) => {
                                        setDate(newDate);
                                        setFormData(prevState => ({
                                            ...prevState,
                                            NtcbrdDt: newDate.format("YYYY-MM-DD")
                                        }));
                                    }}
                                    slotProps={{ textField: { size: 'small', fullWidth: true, }, }}
                                    format="DD/MM/YYYY"
                                />
                            </LocalizationProvider>
                        </Grid>

                        {/* Board Subject */}
                        <Grid item xs={12}>
                            <TextField
                                id="NtcbrdSubj"
                                name="NtcbrdSubj"
                                label="Title/Subject"
                                variant="filled"
                                fullWidth
                                className="custom-textfield"
                                value={formData.NtcbrdSubj}
                                disabled={isFormDisabled}
                                onChange={handleInputChange}
                                color="primary"
                            />
                        </Grid>

                        {/* Board Description */}
                        <Grid item xs={12} md={9}>
                            <Typography variant="h6" color={purple[600]} gutterBottom>
                                Description
                            </Typography>
                            <ReactQuill
                                id="NtcbrdDesc"
                                name="NtcbrdDesc"
                                variant="filled"
                                fullWidth
                                disabled={isFormDisabled}
                                className="custom-textfield"
                                value={formData.NtcbrdDesc}
                                onChange={InputChange}
                                theme="snow"
                                style={{
                                    height: '190px',
                                    borderRadius: '8px',
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={3} mt={6}>
                            <Box
                                sx={{
                                    marginTop: { xs: 3, md: 0 },
                                    width: 250,
                                    height: 220,
                                    border: '1px solid #080000ff',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#f9f9f9',
                                    boxShadow: 1,
                                    overflow: 'hidden',
                                    position: 'relative',
                                }}
                            >
                                {formData.Attachment ? (
                                    fileType === 'application/pdf' || formData.ImgName?.toLowerCase().endsWith('.pdf') ? (
                                        <Box
                                            sx={{
                                                textAlign: 'center',
                                                p: 2,
                                                cursor: 'pointer',
                                                '&:hover': { backgroundColor: '#f0f0f0' },
                                                borderRadius: '8px',
                                            }}
                                            onClick={() => window.open(formData.Attachment, '_blank')}
                                        >
                                            <DescriptionIcon sx={{ fontSize: 50, color: '#d32f2f' }} />
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    mt: 1,
                                                    fontWeight: 'bold',
                                                    wordBreak: 'break-all',
                                                    color: '#d32f2f',
                                                }}
                                            >
                                                {formData.ImgName || 'PDF File'}
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                Click to open
                                            </Typography>
                                        </Box>
                                    ) : (
                                        <img
                                            alt="preview"
                                            src={formData.Attachment}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                borderRadius: '8px',
                                            }}
                                            onClick={() => window.open(formData.Attachment, '_blank')}
                                            title="Click to view full size"
                                        />
                                    )
                                ) : (
                                    <Typography variant="body2" color="textSecondary">
                                        No Attachment
                                    </Typography>
                                )}
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' }, alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                <Button
                                    variant="contained"
                                    component="label"
                                    disabled={isFormDisabled}
                                    startIcon={<CloudUpload />}
                                    sx={{
                                        backgroundColor: teal[600],
                                        color: 'white',
                                        '&:hover': { backgroundColor: teal[700] },
                                        padding: '7px 10px',
                                        borderRadius: '8px',
                                        textTransform: 'none',
                                        boxShadow: 2,
                                    }}
                                >
                                    Attachment
                                    <input
                                        type="file"
                                        hidden
                                        accept=".pdf,.jpeg,.jpg,.xlsx,.png"
                                        onChange={handleFileChange}
                                    />
                                </Button>

                                {mode === 'view' && (
                                    <>
                                        <Button variant='contained' sx={{ background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                                            Submit
                                        </Button>
                                        <Button variant='contained' sx={{ background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit} disabled>
                                            Cancel
                                        </Button>
                                    </>
                                )}

                                {(mode === 'add' || mode === 'edit') && (
                                    <>
                                        <Button
                                            variant="contained"
                                            onClick={handleSubmit}
                                            sx={{
                                                backgroundColor: '#635bff',
                                                '&:hover': { backgroundColor: '#453cf5' },
                                                boxShadow: 2,
                                            }}
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            onClick={handleCancel}
                                            sx={{
                                                borderColor: '#635bff',
                                                color: '#635bff',
                                                '&:hover': {
                                                    borderColor: '#453cf5',
                                                    color: '#453cf5',
                                                    backgroundColor: 'rgba(99, 91, 255, 0.04)',
                                                },
                                                boxShadow: 2,
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>

            <Grid item xs={12} md={6}>
                <Dialog
                    open={openConfirmDialog}
                    onClose={closeConfirmation}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{
                        "& .MuiDialog-paper": {
                            maxWidth: "sm",
                            width: { xs: "80%", sm: "600px", md: "690px", lg: "400px", xl: "800px" },
                            height: "auto",
                            padding: { xs: "10px", sm: "15px", md: "10px", lg: "10px", xl: "10px" },
                            backgroundColor: "white",
                            borderRadius: "10px",
                            border: "1px solid #ccc",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        },
                    }}
                >
                    <DialogTitle id="alert-dialog-title"
                        sx={{
                            padding: '16px 16px',
                        }}
                    >
                        <Grid container>
                            <Box
                                sx={{
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                    backgroundColor: "transparent",
                                    overflow: "hidden",
                                    margin: "0px 0px 0px 1px",
                                    padding: "10px",
                                    gap: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    maxWidth: "1000px",
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    align="center"
                                    sx={{
                                        fontWeight: "bold",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundImage: "linear-gradient(to right, #1976d2, #7b1fa2, #b8110cff)",
                                        WebkitBackgroundClip: "text",
                                        color: "transparent",
                                    }}
                                >
                                    <HouseIcon sx={{ marginRight: 1, color: "#1976d2" }} />
                                    Property Selection
                                </Typography>

                                <TextField
                                    variant="outlined"
                                    placeholder="Search your property..."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    sx={{
                                        width: "100%",
                                        marginBottom: "10px",
                                        borderRadius: "4px",
                                        padding: "8px",
                                    }}
                                />

                                {/* Property List */}
                                <FormGroup sx={{ marginBottom: 2, display: "flex", flexDirection: "column" }}>
                                    {filteredProperties.length > 0 ? (
                                        filteredProperties.map((option, index) => (
                                            <FormControlLabel
                                                key={index}
                                                control={<Checkbox value={option.PropId} onChange={handleCheckboxChange} />}
                                                label={option.Name}
                                            />
                                        ))
                                    ) : (
                                        <Typography variant="body2" align="center">
                                            No properties found matching your search.
                                        </Typography>
                                    )}
                                </FormGroup>

                                {/* Buttons */}
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 2, marginBottom: 1 }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSave}
                                        sx={{
                                            width: "30%",
                                            padding: "6px 10px",
                                            fontWeight: "bold",
                                            backgroundColor: "#1976d2",
                                            "&:hover": { backgroundColor: "#1565c0" },
                                            borderRadius: '9px'
                                        }}
                                    >
                                        Save
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        onClick={closeConfirmation}
                                        sx={{
                                            width: "30%",
                                            padding: "6px 10px",
                                            fontWeight: "bold",
                                            borderColor: "#ca1508ff",
                                            color: "#d21919ff",
                                            "&:hover": { borderColor: "#ca1508ff", color: "#ca1508ff" },
                                            borderRadius: '9px'
                                        }}
                                    >
                                        Close
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                    </DialogTitle>
                </Dialog>

                <ConfirmationDialog
                    open={openDelete}
                    onClose={handleDeleteCancel}
                    onConfirm={handleDeleteConfirm}
                    title="Confirm Deletion"
                    message="Are you sure you want to delete this notice?"
                />
            </Grid>
        </>
    );
}

export default InfoBoard;